import {
  ApiPublicConfig,
  ApiPublicConfigError,
  PublicConfigParams,
} from "@services/types/identity/identityTypes";
import { toTenantCode } from "@utils/tenant";

const getErrorMessage = (response: Response, publicConfig: ApiPublicConfigError) => {
  if (response?.status !== 200) {
    return publicConfig?.non_field_errors?.[0];
  }

  return "";
};

export const loadPublicConfig = async ({
  identityUrl,
  environment,
  onSuccess,
  onError,
}: PublicConfigParams) => {
  try {
    const serviceCode = "darwin-front";
    // The API expects the normalized tenant code, without the "-{environment}" suffix.
    const tenantCode = toTenantCode(window?.location?.hostname, environment);

    // Create the request URL with query parameters
    const servicePath = "/api/v1/services/public-config/";
    const apiPath = `${identityUrl}${servicePath}`;
    const params = `?tenant_code=${tenantCode}&service_code=${serviceCode}&environment=${environment}`;
    const request = new Request(`${apiPath}${params}`, {
      method: "GET",
    });

    const response = await fetch(request);
    const publicConfig: ApiPublicConfig = await response.json();

    if (response?.status === 200) {
      onSuccess?.(publicConfig);
    } else {
      const errorMessage = getErrorMessage(
        response,
        publicConfig as unknown as ApiPublicConfigError,
      );

      onError?.(response, errorMessage);
    }

    return publicConfig;
  } catch (error) {
    onError?.(error);
  }
};
